<template>
  <div class="col-12-">
    <div class="search-padd">
      <table class="table table-sm table-borderless shadow">
        <thead>
          <tr class="">
            <th>Assessment Name</th>
            <th class="text-center"># of Assigned</th>
            <th class="text-center"># of Completed</th>
            <th class="text-center">Last Updated</th>
            <th class="text-center">Status</th>
            <th class="text-center">Date Created</th>
            <!-- <th>Assign to</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-show="loading">
            <td colspan="6">
              <div class="loading_show"><div class="spinner-border text-danger"></div></div>
            </td>
          </tr>          
          <tr v-for="(assessment, index) in assessment_lists">
            <td>{{ assessment.name }}</td>
            <td class="text-center">{{ assessment.no_of_assigned }}</td>
            <td class="text-center">{{ assessment.no_of_completed }}</td>
            <td class="text-center">{{ getDate(assessment.updated_at) }}</td>
            <td class="text-center">{{ getStatus(assessment.status) }}</td>
            <td class="text-center">{{ getDate(assessment.created_at) }}</td>
            <!-- <td><button class="btn input-height-15 rounded">Select Users</button></td> -->
          </tr>
          <tr v-if="assessment_lists.length == 0">
            <td colspan="6" class="text-center">No assessments found</td>
          </tr>          
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  props: ['accountId'],
  data() {
    return {
      loading: false,
      assessment_lists: [],
      status_options: [
        { value: '', text: 'Status' },
        { value: 'DRAFT', text: 'Draft' },
        { value: 'PUBLISH', text: 'Published' },
        { value: 'DEACTIVATED', text: 'Deactivated' }
      ],
    }
  },
  methods: {
    fetchAssessmentListItems() {
      this.loading = true;
      const params = {
        accountId: this.accountId,
        user_roles: 'ROLE_MENTEE',
      };
      axios.get('/pathway-assessment-lists', {
          params: params
      })
      .then((resp) => {
          this.loading = false;
          this.assessment_lists = resp.data;
      })
      .catch(error => {});
    },
    getStatus: function(status) {
      var status_val = this.status_options.findIndex(item => item.value === status);
      return this.status_options[status_val].text;
    },
    getDate(value) {
      return moment(String(value)).utc().format('MM/DD/YYYY')
    },
  },
  created() {
    this.fetchAssessmentListItems();
  },
}

</script>

<style scoped>
table thead tr {
  background-color: #00ACEE;
  color: #FFFFFF;
}

table tbody button {
  background-color: white;
  color: black;
  border: 1px solid black;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_pathway_assessment_lists.vue